var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorStatusV2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.883 8.099 6.723.989C6.39.444 5.59.444 5.277.99L1.097 8.1a.822.822 0 0 0 .723 1.23h8.34a.822.822 0 0 0 .723-1.23zM5.53 3.236c0-.254.196-.469.469-.469.254 0 .469.215.469.469v2.5A.463.463 0 0 1 6 6.204a.475.475 0 0 1-.469-.468v-2.5zM6 8.079a.613.613 0 0 1-.625-.605c0-.332.273-.605.625-.605.332 0 .605.273.605.605A.609.609 0 0 1 6 8.079z",
    fill: "#EEC01F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorStatusV2);
export default __webpack_public_path__ + "static/media/error-status-v2.4e50ec29726a2fb15310a7e17b1e0424.svg";
export { ForwardRef as ReactComponent };